import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import DashboardLayout from './components/Layout/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Analytics from './pages/Analytics';
import FleetManagement from './pages/FleetManagement';
import Bookings from './pages/Bookings';
import BlogManagement from './pages/BlogManagement';
import BlogEditor from './components/Blog/BlogEditor';
import WebsiteCMS from './pages/WebsiteCMS';
import UserManagement from './pages/UserManagement';
import CustomerManagement from './pages/CustomerManagement';
import Discounts from './pages/Discounts';
import Settings from './pages/Settings';
import SystemHealth from './pages/SystemHealth';
import WebsiteAnalytics from './pages/WebsiteAnalytics';
import Notifications from './pages/Notifications';
import SEODashboard from './pages/SEODashboard';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/" element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }>
              <Route path="dashboard" element={
                <ProtectedRoute requiredPermission="view_dashboard">
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="analytics" element={
                <ProtectedRoute requiredPermission="view_analytics">
                  <Analytics />
                </ProtectedRoute>
              } />
              <Route path="fleet" element={
                <ProtectedRoute requiredPermission="manage_fleet">
                  <FleetManagement />
                </ProtectedRoute>
              } />
              <Route path="bookings" element={
                <ProtectedRoute requiredPermission="manage_bookings">
                  <Bookings />
                </ProtectedRoute>
              } />
              <Route path="blog" element={
                <ProtectedRoute requiredPermission="view_dashboard">
                  <BlogManagement />
                </ProtectedRoute>
              } />
              <Route path="blog/editor" element={
                <ProtectedRoute requiredPermission="view_dashboard">
                  <BlogEditor />
                </ProtectedRoute>
              } />
              <Route path="blog/editor/:id" element={
                <ProtectedRoute requiredPermission="view_dashboard">
                  <BlogEditor />
                </ProtectedRoute>
              } />
              <Route path="pages" element={
                <ProtectedRoute requiredPermission="view_dashboard">
                  <WebsiteCMS />
                </ProtectedRoute>
              } />
              <Route path="notifications" element={
                <ProtectedRoute requiredPermission="view_dashboard">
                  <Notifications />
                </ProtectedRoute>
              } />
              <Route path="users" element={
                <ProtectedRoute requiredPermission="manage_users">
                  <UserManagement />
                </ProtectedRoute>
              } />
              <Route path="discounts" element={
                <ProtectedRoute requiredPermission="manage_discounts">
                  <Discounts />
                </ProtectedRoute>
              } />
              <Route path="customers" element={
                <ProtectedRoute requiredPermission="view_dashboard">
                  <CustomerManagement />
                </ProtectedRoute>
              } />
              <Route path="settings" element={
                <ProtectedRoute requiredPermission="manage_settings">
                  <Settings />
                </ProtectedRoute>
              } />
              <Route path="system-health" element={
                <ProtectedRoute requiredPermission="view_dashboard">
                  <SystemHealth />
                </ProtectedRoute>
              } />
              <Route path="website-analytics" element={
                <ProtectedRoute requiredPermission="view_analytics">
                  <WebsiteAnalytics />
                </ProtectedRoute>
              } />
              <Route path="seo" element={
                <ProtectedRoute requiredPermission="view_dashboard">
                  <SEODashboard />
                </ProtectedRoute>
              } />
            </Route>
          </Routes>
        </Router>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#4ade80',
                secondary: '#fff',
              },
            },
            error: {
              duration: 4000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
